import createReducer from '../utils/createReducer';

/*
    This reducer is currently not tested due to lack of functionality.
*/
const initialState = {};

const actionHandlers = {};

export default createReducer(actionHandlers, initialState);
